import { render, staticRenderFns } from "./PaySuccessShoreExcursions.vue?vue&type=template&id=6fbaf0b2&scoped=true"
import script from "./PaySuccessShoreExcursions.vue?vue&type=script&lang=js"
export * from "./PaySuccessShoreExcursions.vue?vue&type=script&lang=js"
import style0 from "./PaySuccessShoreExcursions.vue?vue&type=style&index=0&id=6fbaf0b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbaf0b2",
  null
  
)

export default component.exports